import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/launch',
    name: 'Launch',
    component: () => import('../views/Launch.vue')
  },
  {
    path: '/resource',
    name: 'Resource',
    component: () => import('../views/Resource.vue')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
